import { render, staticRenderFns } from "./hosts.vue?vue&type=template&id=0bfb2290"
import script from "./hosts.vue?vue&type=script&lang=js"
export * from "./hosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports